import React from 'react';
import S from './StyledSection.styles';
const StyledSection = ({ includeCorners, children }) => {
    return React.createElement(S.StyledSection, { showCorners: includeCorners }, children);
};
export default StyledSection;
